import React from "react";
import { Link , NavLink} from "react-router-dom";
import { Translate } from 'react-localize-redux';

export default function Schedule() {
  return (
    <React.Fragment>
      <div class="card card-bottom-tabs">
        <div class="card-block">
          <h4 class="card-title m-t-0"><Translate id="general.ScheduleTitle"/></h4>
          <h6 class="card-subtitle m-b-10 text-muted">
            View Schedule of student week by week.
          </h6>
        </div>
      </div>

      <ul class="nav card-bottom-tabsUL">
        <li class="nav-items">
          <Link to={`/Schedule/Weekly/`} className="nav-link  " activeClassName='active'>
            <span class="d-sm-none">
              <i class="fas fa-info fa-fw text-primecolor" /> <Translate id="general.WeeklyScheduleTitle"/>
            </span>
            <span class="d-sm-block d-none">
              <i class="fas fa-info fa-fw  text-primecolor" /> <Translate id="general.WeeklyScheduleTitle"/>
            </span>
          </Link>
        </li>

        <li class="nav-items">
          <NavLink to={`/Schedule/General`} className="nav-link"  activeClassName='active'> 
            <span class="d-sm-none">
              <i class="fa fa-fw fa-book text-primecolor" /> <Translate id="general.GeneralScheduleTitle"/>
            </span>
            <span class="d-sm-block d-none">
              <i class="fa fa-fw fa-book text-primecolor" /> <Translate id="general.GeneralScheduleTitle"/>
            </span>
          </NavLink>
        </li>
      </ul>
      <br />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/student_schedule/Schedule.js